module.exports = __webpack_public_path__ + "fonts/checkbox-sign-in-widget@2x.c8c027005764d43d83566d88f53844c9.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/forms/checkbox-sign-in-widget@2x.png
// module id = 293
// module chunks = 9